import { render } from "./DatePicker.vue?vue&type=template&id=06b27787"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"

import "./DatePicker.vue?vue&type=style&index=0&id=06b27787&lang=scss"
script.render = render

export default script